import { type Filter, type FilterGroup } from './defs';

const createFilters = (init?: Partial<Filter>): Filter => {
  return Object.assign(
    {
      title: '',
      queryKey: null,
      queryValue: '1',
      requestKey: null,
      requestValue: '1',
      pillText: null,
      pillOrder: 0,
      menuOrder: 0,
      hidden: false,
      tag: null,
      isNew: false,

      type: '',
      options: [],
    },
    init
  );
};

const productFilters: FilterGroup = {
  topFilters: [],
  bottomFilters: [
    createFilters({
      title: 'Dietary Needs',
      type: 'and',
      menuOrder: 2,
      pillOrder: 1,
      pillText: 'Diet',
      options: [
        createFilters({
          title: 'Vegan',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'is_vegan',
          queryKey: 'is_vegan',
        }),
        createFilters({
          title: 'Vegetarian',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'is_vegetarian',
          queryKey: 'is_vegetarian',
        }),
        createFilters({
          title: 'Pescatarian',
          menuOrder: 3,
          pillOrder: 3,
          requestKey: 'is_pescatarian',
          queryKey: 'is_pescatarian',
        }),
        createFilters({
          title: 'Dairy-Free',
          menuOrder: 4,
          pillOrder: 4,
          requestKey: 'is_dairy_free',
          queryKey: 'is_dairy_free',
        }),
        createFilters({
          title: 'Gluten-Free',
          menuOrder: 5,
          pillOrder: 5,
          requestKey: 'is_gluten_free',
          queryKey: 'is_gluten_free',
        }),
        createFilters({
          title: 'Soy-Free',
          menuOrder: 6,
          pillOrder: 6,
          requestKey: 'is_soy_free',
          queryKey: 'is_soy_free',
        }),
        createFilters({
          title: 'Tree Nut-Free',
          menuOrder: 7,
          pillOrder: 7,
          requestKey: 'is_nut_free',
          queryKey: 'is_nut_free',
        }),
        createFilters({
          title: 'Peanut-Free',
          menuOrder: 8,
          pillOrder: 8,
          requestKey: 'is_peanut_free',
          queryKey: 'is_peanut_free',
        }),
        createFilters({
          title: 'Egg-Free',
          menuOrder: 9,
          pillOrder: 9,
          requestKey: 'is_egg_free',
          queryKey: 'is_egg_free',
        }),
        createFilters({
          title: 'Shellfish-Free',
          menuOrder: 10,
          pillOrder: 10,
          requestKey: 'is_shellfish_free',
          queryKey: 'is_shellfish_free',
        }),
      ],
    }),
    createFilters({
      title: 'Featured',
      type: 'split_or',
      menuOrder: 3,
      pillOrder: 9999,
      options: [
        createFilters({
          menuOrder: 7,
          pillOrder: 7,
          pillText: `Heat and Eat`,
          queryKey: 'is_heat_and_eat',
          queryValue: '1',
          requestKey: 'marketing_tags',
          requestValue: '195',
          tag: 195,
          title: `Heat and Eat`,
          type: 'toggle',
        }),
        createFilters({
          title: 'Breakfast-Friendly',
          type: 'toggle',
          menuOrder: 1,
          pillOrder: 3,
          tag: 47,
          requestKey: 'is_breakfast',
          queryKey: 'is_breakfast',
        }),
        createFilters({
          title: 'Lunch-Friendly',
          type: 'toggle',
          menuOrder: 2,
          pillOrder: 4,
          tag: 48,
          requestKey: 'occasion_tags',
          requestValue: '48',
          queryKey: 'is_lunch',
        }),
        createFilters({
          title: 'Kid-Friendly',
          type: 'toggle',
          menuOrder: 3,
          pillOrder: 10,
          tag: 175,
          requestKey: 'occasion_tags',
          requestValue: '175',
          queryKey: 'is_kid_friendly',
          hidden: true,
        }),
        createFilters({
          title: 'Newest Additions',
          pillText: 'New',
          type: 'toggle',
          menuOrder: 4,
          pillOrder: 8,
          requestKey: 'is_new',
          queryKey: 'is_new',
        }),
        createFilters({
          title: 'Recent Groceries',
          pillText: 'Recently Tried',
          type: 'toggle',
          menuOrder: 5,
          pillOrder: 10,
          requestKey: 'is_recent',
          queryKey: 'is_recent',
        }),
        createFilters({
          menuOrder: 6,
          pillOrder: 6,
          pillText: `Dietitian's Picks`,
          queryKey: 'is_marketing',
          queryValue: '1',
          requestKey: 'marketing_tags',
          requestValue: '124',
          tag: 124,
          title: `Dietitian's Picks`,
          type: 'toggle',
        }),
        createFilters({
          menuOrder: 6,
          pillOrder: 6,
          pillText: `Best Price`,
          queryKey: 'is_best_price',
          queryValue: '1',
          requestKey: 'marketing_tags',
          requestValue: '245',
          tag: 245,
          title: `Best Price`,
          type: 'toggle',
        }),
        createFilters({
          menuOrder: 6,
          pillOrder: 6,
          pillText: `Support Your System`,
          queryKey: 'is_marketing',
          queryValue: '2',
          requestKey: 'marketing_tags',
          requestValue: '194',
          tag: 194,
          title: `Support Your System`,
          type: 'toggle',
        }),
        createFilters({
          hidden: true,
          menuOrder: 6,
          pillOrder: 12,
          queryKey: 'is_marketing',
          queryValue: '1',
          requestKey: 'marketing_tags',
          requestValue: '124',
          tag: 124,
          title: 'Eat Well, Feel Well',
          type: 'toggle',
        }),
        createFilters({
          title: 'Sweet Treats for V-Day',
          type: 'toggle',
          menuOrder: 7,
          pillOrder: 13,
          tag: 194,
          requestKey: 'marketing_tags',
          requestValue: '194',
          queryKey: 'is_marketing',
          queryValue: '2',
          hidden: true,
        }),
        createFilters({
          title: 'Surprisingly Vegan',
          type: 'toggle',
          menuOrder: 8,
          pillOrder: 14,
          tag: 195,
          requestKey: 'marketing_tags',
          requestValue: '195',
          queryKey: 'is_marketing',
          queryValue: '3',
          hidden: true,
        }),
        createFilters({
          title: 'Game Day',
          type: 'toggle',
          menuOrder: 9,
          pillOrder: 20,
          tag: 4173,
          requestKey: 'marketing_tags',
          requestValue: '4173',
          queryKey: 'is_game_day',
          queryValue: '1',
          hidden: false,
        }),
        createFilters({
          title: 'Immunity Boosters',
          type: 'toggle',
          menuOrder: 10,
          pillOrder: 21,
          tag: 4174,
          requestKey: 'marketing_tags',
          requestValue: '4174',
          queryKey: 'is_immunity_boosters',
          queryValue: '1',
          hidden: false,
        }),
      ],
    }),
    createFilters({
      title: 'Your Groceries',
      type: 'choose_one',
      menuOrder: 1,
      pillOrder: 10,
      options: [
        createFilters({
          title: 'Saved Groceries',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'is_favorite',
          queryKey: 'is_favorite',
        }),
        createFilters({
          title: 'Recent Groceries',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'is_recent',
          queryKey: 'is_recent',
        }),
      ],
    }),
    createFilters({
      title: 'Protein',
      type: 'or',
      menuOrder: 4,
      pillOrder: 2,
      options: [
        createFilters({
          title: 'Ground Beef',
          menuOrder: 1,
          pillOrder: 1,
          tag: 802,
          requestKey: 'protein_tags',
          requestValue: '802',
          queryKey: 'protein',
          queryValue: '802',
        }),
        createFilters({
          title: 'Steak',
          menuOrder: 2,
          pillOrder: 2,
          tag: 795,
          requestKey: 'protein_tags',
          requestValue: '795',
          queryKey: 'protein',
          queryValue: '795',
        }),
        createFilters({
          title: 'Bison',
          menuOrder: 3,
          pillOrder: 3,
          tag: 794,
          requestKey: 'protein_tags',
          requestValue: '794',
          queryKey: 'protein',
          queryValue: '794',
        }),
        createFilters({
          title: 'Chicken',
          menuOrder: 4,
          pillOrder: 4,
          tag: 804,
          requestKey: 'protein_tags',
          requestValue: '804',
          queryKey: 'protein',
          queryValue: '804',
        }),
        createFilters({
          title: 'Turkey',
          menuOrder: 5,
          pillOrder: 5,
          tag: 803,
          requestKey: 'protein_tags',
          requestValue: '803',
          queryKey: 'protein',
          queryValue: '803',
        }),
        createFilters({
          title: 'Pork',
          menuOrder: 6,
          pillOrder: 6,
          tag: 3,
          requestKey: 'protein_tags',
          requestValue: '3',
          queryKey: 'protein',
          queryValue: '3',
        }),
        createFilters({
          title: 'Lamb',
          menuOrder: 7,
          pillOrder: 7,
          tag: 16,
          requestKey: 'protein_tags',
          requestValue: '16',
          queryKey: 'protein',
          queryValue: '16',
        }),
        createFilters({
          title: 'Salmon',
          menuOrder: 8,
          pillOrder: 8,
          tag: 801,
          requestKey: 'protein_tags',
          requestValue: '801',
          queryKey: 'protein',
          queryValue: '801',
        }),
        createFilters({
          title: 'Tuna',
          menuOrder: 9,
          pillOrder: 9,
          tag: 796,
          requestKey: 'protein_tags',
          requestValue: '796',
          queryKey: 'protein',
          queryValue: '796',
        }),
        createFilters({
          title: 'Trout',
          menuOrder: 10,
          pillOrder: 10,
          tag: 797,
          requestKey: 'protein_tags',
          requestValue: '797',
          queryKey: 'protein',
          queryValue: '797',
        }),
        createFilters({
          title: 'Whitefish',
          menuOrder: 11,
          pillOrder: 11,
          tag: 798,
          requestKey: 'protein_tags',
          requestValue: '798',
          queryKey: 'protein',
          queryValue: '798',
        }),
        createFilters({
          title: 'Shellfish',
          menuOrder: 12,
          pillOrder: 12,
          tag: 5,
          requestKey: 'protein_tags',
          requestValue: '5',
          queryKey: 'protein',
          queryValue: '5',
        }),
        createFilters({
          title: 'Smoked Fish',
          menuOrder: 13,
          pillOrder: 13,
          tag: 6,
          requestKey: 'protein_tags',
          requestValue: '6',
          queryKey: 'protein',
          queryValue: '6',
        }),
        createFilters({
          title: 'Tofu + Tempeh',
          menuOrder: 14,
          pillOrder: 14,
          tag: 7,
          requestKey: 'protein_tags',
          requestValue: '7',
          queryKey: 'protein',
          queryValue: '7',
        }),
        createFilters({
          title: 'Beans + Lentils',
          menuOrder: 15,
          pillOrder: 15,
          tag: 9,
          requestKey: 'protein_tags',
          requestValue: '9',
          queryKey: 'protein',
          queryValue: '9',
        }),
        createFilters({
          title: "Plant-based 'Meat' Alternatives",
          menuOrder: 16,
          pillOrder: 16,
          tag: 10,
          requestKey: 'protein_tags',
          requestValue: '10',
          queryKey: 'protein',
          queryValue: '10',
        }),
      ],
    }),
    createFilters({
      title: 'Sort',
      type: 'choose_one',
      menuOrder: 6,
      pillOrder: 7,
      options: [
        createFilters({
          title: 'Personalized (Default)',
          pillText: 'Personalized',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'sort_by_default',
          queryKey: 'sort_by_default',
        }),
        createFilters({
          title: 'Credits',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'sort',
          requestValue: 'points',
          queryKey: 'sort_by_points',
        }),
      ],
    }),
    createFilters({
      title: 'Nutrition',
      type: 'and',
      menuOrder: 5,
      pillOrder: 5,
      options: [
        createFilters({
          title: 'Carb Conscious (<10g)',
          menuOrder: 1,
          pillOrder: 1,
          tag: 23,
          requestKey: 'nutrition_tags',
          requestValue: '23',
          queryKey: 'is_carb_conscious',
        }),
        createFilters({
          title: 'Less Sugar (<2g)',
          menuOrder: 2,
          pillOrder: 2,
          tag: 24,
          requestKey: 'nutrition_tags',
          requestValue: '24',
          queryKey: 'is_less_sugar',
        }),
        createFilters({
          title: 'High Protein (>10g)',
          menuOrder: 3,
          pillOrder: 3,
          tag: 25,
          requestKey: 'nutrition_tags',
          requestValue: '25',
          queryKey: 'is_high_protein',
        }),
        createFilters({
          title: 'Less Sodium (<140mg)',
          menuOrder: 4,
          pillOrder: 4,
          tag: 26,
          requestKey: 'nutrition_tags',
          requestValue: '26',
          queryKey: 'is_less_sodium',
        }),
        createFilters({
          title: 'No Added Sugar',
          menuOrder: 5,
          pillOrder: 5,
          tag: 186,
          requestKey: 'certification_tags',
          requestValue: '186',
          queryKey: 'is_no_sugar',
        }),
        createFilters({
          title: 'Paleo-Friendly',
          menuOrder: 6,
          pillOrder: 6,
          tag: 145,
          requestKey: 'nutrition_tags',
          requestValue: '145',
          queryKey: 'is_paleo',
        }),
        createFilters({
          title: 'Anti-inflammatory',
          menuOrder: 7,
          pillOrder: 7,
          tag: 242,
          requestKey: 'nutrition_tags',
          requestValue: '242',
          queryKey: 'is_anti_inflammatory',
        }),
        createFilters({
          title: 'Low FODMAP',
          menuOrder: 8,
          pillOrder: 8,
          tag: 666,
          requestKey: 'nutrition_tags',
          requestValue: '666',
          queryKey: 'low_fodmap',
        }),
      ],
    }),
    createFilters({
      title: 'Certifications',
      type: 'or',
      menuOrder: 7,
      pillOrder: 9,
      options: [
        createFilters({
          title: 'Organic',
          menuOrder: 1,
          pillOrder: 1,
          tag: 15,
          requestKey: 'certification_tags',
          requestValue: '15,814',
          queryKey: 'certification_tags',
          queryValue: '15,814',
        }),
        createFilters({
          title: 'Non-GMO Project Certified',
          menuOrder: 2,
          pillOrder: 2,
          tag: 49,
          requestKey: 'certification_tags',
          requestValue: '49',
          queryKey: 'certification_tags',
          queryValue: '49',
        }),
        createFilters({
          title: 'Certified Kosher',
          menuOrder: 3,
          pillOrder: 3,
          tag: 141,
          requestKey: 'certification_tags',
          requestValue: '141',
          queryKey: 'certification_tags',
          queryValue: '141',
        }),
        createFilters({
          title: 'Certified Gluten-Free',
          menuOrder: 4,
          pillOrder: 4,
          tag: 142,
          requestKey: 'certification_tags',
          requestValue: '142',
          queryKey: 'certification_tags',
          queryValue: '142',
        }),
      ],
    }),

    createFilters({
      title: 'Spice Level',
      type: 'or',
      menuOrder: 8,
      pillOrder: 10,
      pillText: 'Spice',
      options: [
        createFilters({
          title: 'No Heat',
          menuOrder: 1,
          pillOrder: 1,
          tag: 19,
          requestKey: 'spicy_levels',
          requestValue: '0',
          queryKey: 'spicy_level',
          queryValue: '0',
        }),
        createFilters({
          title: 'Mild',
          menuOrder: 2,
          pillOrder: 2,
          tag: 20,
          requestKey: 'spicy_levels',
          requestValue: '1',
          queryKey: 'spicy_level',
          queryValue: '1',
        }),
        createFilters({
          title: 'Medium',
          menuOrder: 3,
          pillOrder: 3,
          tag: 21,
          requestKey: 'spicy_levels',
          requestValue: '2',
          queryKey: 'spicy_level',
          queryValue: '2',
        }),
        createFilters({
          title: 'Hot',
          menuOrder: 4,
          pillOrder: 4,
          tag: 22,
          requestKey: 'spicy_levels',
          requestValue: '3',
          queryKey: 'spicy_level',
          queryValue: '3',
        }),
      ],
    }),
  ],
  query: '',
};

// Remove hidden props once before exporting
productFilters.bottomFilters = productFilters.bottomFilters.filter(
  (f) => !f.hidden
);
productFilters.bottomFilters.forEach((f) => {
  f.options = f.options.filter((o) => !o.hidden);
});

export { productFilters };
